import type { OrderClientListItem } from '@swiftpay/shared';

/** Глубина окна агрегации в неделях (включая текущую). */
export const WEEKS = 10;
const DAY_MS = 86_400_000;

/** Понедельник недели, к которой относится дата (локальное время, полночь). */
export function weekStart(d: Date): number {
  const x = new Date(d.getFullYear(), d.getMonth(), d.getDate());
  // getDay(): 0 = воскресенье, поэтому сдвиг до понедельника = (day + 6) % 7.
  x.setDate(x.getDate() - ((x.getDay() + 6) % 7));
  return x.getTime();
}

/**
 * Суммы заказов по последним WEEKS ISO-неделям включая текущую.
 * Недели без заказов дают 0 — синтетики нет, только реальная агрегация.
 */
export function weeklySums(
  orders: OrderClientListItem[],
  dateOf: (o: OrderClientListItem) => string | null,
): number[] {
  const current = weekStart(new Date());
  const buckets = new Array<number>(WEEKS).fill(0);
  for (const o of orders) {
    const raw = dateOf(o);
    if (!raw) continue;
    const d = new Date(raw);
    if (Number.isNaN(d.getTime())) continue;
    // Индекс с конца: 0 — самая старая из окна, WEEKS-1 — текущая неделя.
    const idx = WEEKS - 1 - Math.round((current - weekStart(d)) / (7 * DAY_MS));
    if (idx < 0 || idx >= WEEKS) continue;
    buckets[idx] = (buckets[idx] ?? 0) + (Number.parseFloat(o.totalAmount) || 0);
  }
  return buckets;
}

/**
 * Мини-график тренда. Ничего не рисует, если точек меньше двух или все нули —
 * плоская линия на пустых данных читалась бы как «данные есть, но ровные».
 */
export function Sparkline({ points, color }: { points: number[]; color: string }) {
  if (points.length < 2 || points.every((v) => v === 0)) return null;
  const min = Math.min(...points);
  const max = Math.max(...points);
  const span = max - min || 1;
  const step = 96 / (points.length - 1);
  const d = points.map((v, i) => `${(i * step).toFixed(1)},${(27 - ((v - min) / span) * 24).toFixed(1)}`).join(' ');
  return (
    <svg width={96} height={30} viewBox="0 0 96 30" fill="none" aria-hidden style={{ flexShrink: 0 }}>
      <polyline
        points={d}
        fill="none"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
